var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "24px",
    viewBox: "0 0 19 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "selected-icon@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-|-Design-|-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-/-General",
    transform: "translate(-461.000000, -725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(409.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "preview-area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 561.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-gesture-/-point-down",
    transform: "translate(52.500000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.61782759,12.8907778 C2.511,12.8907778 3.23472414,12.1776111 3.23472414,11.2982222 L3.23472414,12.8907778 C3.23472414,13.8294444 4.00872414,14.5902778 4.96210345,14.5902778 C5.91486207,14.5902778 6.68762069,13.8294444 6.68762069,12.8907778 C6.68762069,13.8294444 7.461,14.5902778 8.41437931,14.5902778 C9.36713793,14.5902778 10.1398966,13.8294444 10.1398966,12.8907778 L10.1398966,20.4722222 C10.1398966,21.2880556 10.8121034,21.9492778 11.6401034,21.9492778 C12.4687241,21.9492778 13.1403103,21.2880556 13.1403103,20.4722222 L13.1403103,9.19233333 C13.1403103,10.3461111 13.5077586,11.2334444 14.0992759,12.1024444 C14.7851379,13.1089444 16.1252069,13.4554444 17.225069,12.9103333 C17.7191379,12.6646667 17.9072069,12.0627222 17.6384483,11.5860556 L16.2679655,9.16116667 C15.624931,8.02327778 15.1221724,6.81388889 14.769,5.55805556 C14.2625172,3.75222222 13.0863103,2.19816667 11.4725172,1.20388889 C10.1541724,0.3905 8.74024138,0 7.28410345,0 L4.71755172,0 C2.11251724,0 0.000310344827,2.08205556 0.000310344827,4.64505556 L0.000310344827,11.2982222 C0.000310344827,12.1776111 0.724655172,12.8907778 1.61782759,12.8907778",
    id: "Fill-413",
    fill: "#FFCEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2247586,12.9102111 C17.7194483,12.6645444 17.9075172,12.0626 17.6381379,11.5859333 L16.2676552,9.16104444 C15.6252414,8.02315556 15.1218621,6.81376667 14.7693103,5.55854444 C14.2628276,3.7521 13.086,2.19865556 11.4722069,1.20376667 C10.1538621,0.390988889 8.73993103,0.000488888889 7.2837931,0.000488888889 L4.71786207,0.000488888889 C2.1122069,0.000488888889 -5.68434189e-14,2.08193333 -5.68434189e-14,4.64493333 L-5.68434189e-14,7.02337778 C-5.68434189e-14,4.45976667 2.1122069,2.37832222 4.71786207,2.37832222 L7.2837931,2.37832222 C8.73993103,2.37832222 10.1538621,2.76882222 11.4722069,3.58221111 C14.8971724,5.69298889 13.6564138,7.40104444 17.2247586,12.9102111",
    id: "Fill-415",
    fill: "#FFDCD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61782759,12.8907778 C2.511,12.8907778 3.23472414,12.1776111 3.23472414,11.2982222 L3.23472414,12.8907778 C3.23472414,13.8294444 4.00872414,14.5902778 4.96210345,14.5902778 C5.91486207,14.5902778 6.68762069,13.8294444 6.68762069,12.8907778 C6.68762069,13.8294444 7.461,14.5902778 8.41437931,14.5902778 C9.36713793,14.5902778 10.1398966,13.8294444 10.1398966,12.8907778 L10.1398966,20.4722222 C10.1398966,21.2880556 10.8121034,21.9492778 11.6401034,21.9492778 C12.4687241,21.9492778 13.1403103,21.2880556 13.1403103,20.4722222 L13.1403103,9.19233333 C13.1403103,10.3461111 13.5077586,11.2334444 14.0992759,12.1024444 C14.7851379,13.1089444 16.1252069,13.4554444 17.225069,12.9103333 C17.7191379,12.6646667 17.9072069,12.0627222 17.6384483,11.5860556 L16.2679655,9.16116667 C15.624931,8.02327778 15.1221724,6.81388889 14.769,5.55805556 C14.2625172,3.75222222 13.0863103,2.19816667 11.4725172,1.20388889 C10.1541724,0.3905 8.74024138,0 7.28410345,0 L4.71755172,0 C2.11251724,0 0.000310344827,2.08205556 0.000310344827,4.64505556 L0.000310344827,11.2982222 C0.000310344827,12.1776111 0.724655172,12.8907778 1.61782759,12.8907778",
    id: "Fill-417",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61782759,12.8907778 C2.511,12.8907778 3.23472414,12.1776111 3.23472414,11.2982222 L3.23472414,12.8907778 C3.23472414,13.8294444 4.00872414,14.5902778 4.96210345,14.5902778 C5.91486207,14.5902778 6.68762069,13.8294444 6.68762069,12.8907778 C6.68762069,13.8294444 7.461,14.5902778 8.41437931,14.5902778 C9.36713793,14.5902778 10.1398966,13.8294444 10.1398966,12.8907778 L10.1398966,20.4722222 C10.1398966,21.2880556 10.8121034,21.9492778 11.6401034,21.9492778 C12.4687241,21.9492778 13.1403103,21.2880556 13.1403103,20.4722222 L13.1403103,9.19233333 C13.1403103,10.3461111 13.5077586,11.2334444 14.0992759,12.1024444 C14.7851379,13.1089444 16.1252069,13.4554444 17.225069,12.9103333 C17.7191379,12.6646667 17.9072069,12.0627222 17.6384483,11.5860556 L16.2679655,9.16116667 C15.624931,8.02327778 15.1221724,6.81388889 14.769,5.55805556 C14.2625172,3.75222222 13.0863103,2.19816667 11.4725172,1.20388889 C10.1541724,0.3905 8.74024138,0 7.28410345,0 L4.71755172,0 C2.11251724,0 0.000310344827,2.08205556 0.000310344827,4.64505556 L0.000310344827,11.2982222 C0.000310344827,12.1776111 0.724655172,12.8907778 1.61782759,12.8907778 Z",
    id: "Stroke-419",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-424",
    transform: "translate(6.054269, 11.519078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.633289655,1.3717 L0.633289655,0.0920333333",
    id: "Fill-421",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.633289655,1.3717 L0.633289655,0.0920333333",
    id: "Stroke-423",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-428",
    transform: "translate(9.778407, 11.519078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.361737931,1.3717 L0.361737931,0.0920333333",
    id: "Fill-425",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.361737931,1.3717 L0.361737931,0.0920333333",
    id: "Stroke-427",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-432",
    transform: "translate(12.261166, 7.852411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.879393103,1.34010556 L0.879393103,0.199772222",
    id: "Fill-429",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.879393103,1.34010556 L0.879393103,0.199772222",
    id: "Stroke-431",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selected-icon.156ae0f3fd00719ef148807a4bc4b387.svg";
export { ForwardRef as ReactComponent };